import { LegacyAPI, camelcaseKeys } from '@swibeco/shared';

export default {
  deleteBasketItem: async (basketItemId: number) => {
    const response = await LegacyAPI.delete(`/users/basket/${basketItemId}`);
    return camelcaseKeys(response.data);
  },
};
